import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ScanStationUpdateAllRequest } from "../shared/ScanStationUpdateAllRequest";
import { DataService_ScanStationTrackingSU } from "../shared/data.service";

@Component({
	selector: "app-scan-station-su-update-all",
	templateUrl: "./scan-station-su-update-all.component.html",
	styleUrls: ["./scan-station-su-update-all.component.css"],
})
export class ScanStationSuUpdateAllComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: DataService_ScanStationTrackingSU
	) {}

	ngOnInit(): void {
		this.lstScanStation = this.dialogConfig.data.SelectedScanStations;
		this.ScanStationCount = this.lstScanStation.length;

		this.ActiveOption = this.lstActiveOptions[0];
		this.RebuildOption = this.lstRebuildOptions[0];
		this.EntryOption = this.lstModeOptions[0];
		this.ExitOption = this.lstModeOptions[0];
		this.MealOption = this.lstModeOptions[0];
		this.AccessOption = this.lstModeOptions[0];
		this.TimeStampOption = this.lstModeOptions[0];
		this.EventOption = this.lstModeOptions[0];
		this.SqlServerOption = this.lstSqlServerOption[0];
		this.FacilityOption = this.lstFacilityOption[0];
		this.FacilityLocationOption = this.lstFacilityLocationOption[0];

		this.loadFacility();
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////

	lstScanStation: any = [];
	ScanStationCount: number = 0;

	Processing: boolean = false;

	ActiveOption: any;
	RebuildOption: any;
	EntryOption: any;
	ExitOption: any;
	MealOption: any;
	AccessOption: any;
	TimeStampOption: any;
	EventOption: any;
	SqlServerOption: any;
	FacilityOption: any;
	FacilityLocationOption: any;

	lstActiveOptions: any = [
		{
			ID: -1,
			Desc: "Don't Change",
			Color: "Black",
		},
		{
			ID: 1, //Sets IsDecommissioned to 1
			Desc: "Decommission",
			Color: "Red",
		},
		{
			ID: 0,
			Desc: "Activate",
			Color: "Green",
		},
	];

	lstRebuildOptions: any = [
		{
			ID: -1,
			Desc: "Don't Change",
			Color: "Black",
		},
		{
			ID: 1,
			Desc: "Request Rebuild",
			Color: "Green",
		},
		{
			ID: 0,
			Desc: "Cancel Request",
			Color: "Red",
		},
	];

	lstModeOptions: any = [
		{
			ID: -1,
			Desc: "Don't Change",
			Color: "Black",
		},
		{
			ID: 1,
			Desc: "Enable",
			Color: "Green",
		},
		{
			ID: 0,
			Desc: "Disable",
			Color: "Red",
		},
	];

	lstSqlServerOption: any = [
		{
			ID: -1,
			Desc: "Don't Change",
			Color: "Black",
		},
		{
			ID: 1,
			Desc: "Reset to localhost",
			Color: "Green",
		},
	];

	lstFacilityOption: any = [
		{
			ID: -1,
			Desc: "Don't Change",
			Color: "Black",
		},
	];

	lstFacilityLocationOption: any = [
		{
			ID: -1,
			Desc: "Don't Change",
			Color: "Black",
		},
	];

	LoadingFacility: boolean = false;
	LoadingFacilityLocation: boolean = false;

	errorMessage: string = "";

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////

	loadFacility() {
		this.LoadingFacility = true;

		var result = this.dataService.ScanStationSUFacilityOptionSelectList();
		result.subscribe(
			(response) => {
				this.lstFacilityOption = response;

				this.FacilityOption = this.lstFacilityOption[0];

				this.LoadingFacility = false;
			},
			(error) => {
				this.LoadingFacility = false;
			}
		);
	}

	loadFacilityLocation() {
		this.LoadingFacilityLocation = true;

		var result = this.dataService.ScanStationSUFacilityLocationOptionSelectList(this.FacilityOption.ID);
		result.subscribe(
			(response) => {
				this.lstFacilityLocationOption = response;

				this.FacilityLocationOption = this.lstFacilityLocationOption[0];

				this.LoadingFacilityLocation = false;
			},
			(error) => {
				this.LoadingFacilityLocation = false;
			}
		);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onUpdate() {
		this.errorMessage = "";

		if (this.RebuildOption.ID == 1) {
			this.ConfirmRebuild();
		} else {
			this.onFinishUpdate();
		}
	}

	ConfirmRebuild() {
		var Header = "Confirm Rebuild " + this.lstScanStation.length + " ScanStations";
		var Msg = "Are you sure you want to request a rebuild for " + this.lstScanStation.length + " ScanStations? On Larger servers this can take a while.";

		this.confirmationService.confirm({
			key: "updateallconfirmrebuild",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: Header,
			icon: "fa",
			accept: () => {
				this.DoubleCheckRebuild();
			},
			reject: () => {},
		});
	}

	DoubleCheckRebuild() {
		var Header = "Confirm Rebuild " + this.lstScanStation.length + " ScanStations";
		var Msg =
			"NOTE: Doing too many rebuilds at once can slow down larger servers. If you are doing rebuilds overnight MAKE SURE you close the ScanStation program then START SCANSTATION and let the rebuild run with the screen locked. If you turn it off until the next morning they will all try to rebuild in the morning and slow down the server and be unusable until they finish. Do you want to continue?";

		this.confirmationService.confirm({
			key: "updatealldoublecheckrebuild",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: Header,
			icon: "fa",
			accept: () => {
				this.onFinishUpdate();
			},
			reject: () => {},
		});
	}

	onFinishUpdate() {
		this.Processing = true;

		var lstSS: number[] = [];

		for (var z = 0; z < this.lstScanStation.length; z++) {
			var next = this.lstScanStation[z];

			lstSS = [...lstSS, next.ScanStationID];
		}

		var parms: ScanStationUpdateAllRequest = {
			ActiveOption: this.ActiveOption.ID,
			RebuildOption: this.RebuildOption.ID,
			EntryOption: this.EntryOption.ID,
			ExitOption: this.ExitOption.ID,
			MealOption: this.MealOption.ID,
			AccessOption: this.AccessOption.ID,
			TimeStampOption: this.TimeStampOption.ID,
			EventOption: this.EventOption.ID,
			SqlServerOption: this.SqlServerOption.ID,
			FacilityOption: this.FacilityOption.ID,
			FacilityLocationOption: this.FacilityLocationOption.ID,
			lstScanStationIDs: lstSS,
		};

		var result = this.dataService.ScanStationUpdateAll(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "updateall",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: this.ScanStationCount + " ScanStations were updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "updateall",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update ScanStations: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////

	onFacilityOptionChange(val) {
		this.FacilityOption = val;

		this.loadFacilityLocation();
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingFacility == true || this.LoadingFacilityLocation == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////
}
